import { AppConfig } from "@typings/appConfig";
import { CREDIT_CARDS_PROVIDERS } from "@typings/payments";

import {
  CURRENCY_PER_COUNTRY,
  DEFAULT_CLEANING_DURATION_MATRIX,
  DEFAULT_ROOMS_RECOMMENDATION_NUMBER_MATRIX,
} from "@config/consts";
import { AVAILABLE_COUNTRIES } from "@typings/globals";

export const defaultConfig: AppConfig = {
  currency: CURRENCY_PER_COUNTRY[AVAILABLE_COUNTRIES.CH],
  booking: {
    recommendationMatrix: DEFAULT_ROOMS_RECOMMENDATION_NUMBER_MATRIX,
    durationMatrix: DEFAULT_CLEANING_DURATION_MATRIX,
    defaultDuration: 3, // hours
    defaultBedrooms: 2,
    defaultBathrooms: 1,
    minBookingTime: 2,
    minBookingTimeAdmin: 0.5,
    maxBookingTime: 6,
    commitments: {
      enabled: false,
    },
    contactForBooking: {
      sundayEnabled: false,
    },
    serviceVouchers: {
      enabled: false,
      durationMatrix: DEFAULT_CLEANING_DURATION_MATRIX,
      minBookingTime: 2,
      minBookingTimeAdmin: 0.5,
      step: 0.5,
    },
    extraBookingSummary: {
      caption: undefined,
    },
    migrosLinkEnabled: false,
    bookingsToValidate: {
      bankAccountEnabled: false,
      bankAccountText: "",
    },
    extras: {
      windows: {
        times: {
          standard: 6,
          large: 10,
        },
        defaults: {
          standard: 2,
          large: 1,
        },
      },
    },
    hasUrssaf: false,
  },
  b2b: {
    migrosLinkEnabled: false,
    disabledExtrases: [],
    disabledFrequencies: [],
  },
  availableCreditCardsProviders: [
    CREDIT_CARDS_PROVIDERS.VISA,
    CREDIT_CARDS_PROVIDERS.MASTERCARD,
    CREDIT_CARDS_PROVIDERS.AMEX,
  ],
  refRewardAmount: 0,
  referralEnabled: true,
  welcomeRewardAmount: 0,
  marketingConsentEnabled: false,
};
